import { graphql, useStaticQuery } from "gatsby";
import { CategoriesNavType } from "../Types/CategoriesNav.type";

const PollenNavQuery = (): {
  categories: CategoriesNavType[];
} => {
  const {
    pollenCategories: { nodes },
  } = useStaticQuery(graphql`
    {
      pollenCategories: allWpCategory(filter: { name: { ne: "All" } }) {
        nodes {
          id
          link
          slug
          name
        }
      }
    }
  `);
  return {
    categories: nodes,
  };
};

export default PollenNavQuery;
